import {
    GET_ALL_FABRIC_TYPES,
    GET_CATEGORY_LIST,
    GET_DESIGN_LOOK,
    GET_MARKET_LIST,
    GET_PRODUCT_AGE_GROUP_LIST,
    GET_SEASON_LIST,
    GET_SUB_CATEGORY_LIST
} from '../../@types/thunk.types'
import Http from '../../../helpers/Http'
import { FilterOptionTypes } from './FilterOptionReducers'
import {
    SET_AGE_GROUP_LIST,
    SET_ALL_DESIGN_LOOK,
    SET_ALL_FABRIC_TYPES,
    SET_CATEGORY_LIST,
    SET_COMPOSITION_LIST,
    SET_DEPARTMENTS_LIST,
    SET_FABRIC_LIST,
    SET_MARKET_LIST,
    SET_SEASON_LIST,
    SET_SUB_CATEGORY_LIST
} from '../../@types/action.types'
import { toast } from 'react-toastify'
import {
    fetchEnumValues,
    fetchFilterListByBuyer
} from '../../../services/CommonService'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const FilterOptionThunks = {
    [GET_SEASON_LIST]: () => async (dispatch) => {
        await Http.GET('fetchSeasons')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_SEASON_LIST],
                    payload: response.data?.map((item) => ({
                        id: item.constant,
                        name: item.name
                    }))
                })
            })
            .catch(() => {
                toast.error('Failed to load seasons!')
            })
    },
    [GET_MARKET_LIST]: () => async (dispatch) => {
        await Http.GET('fetchMarkets')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_MARKET_LIST],
                    payload: response.data
                })
            })
            .catch(() => {
                toast.error('Failed to load markets!')
            })
    },
    [GET_CATEGORY_LIST]: () => async (dispatch) => {
        await Http.GET('fetchAllCategories')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_CATEGORY_LIST],
                    payload: response.data
                })
            })
            .catch(() => {
                toast.error('Failed to load categories!')
            })
    },
    [GET_SUB_CATEGORY_LIST]: () => async (dispatch) => {
        await Http.GET('fetchCategories')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_SUB_CATEGORY_LIST],
                    payload: response.data
                })
            })
            .catch(() => {
                toast.error('Failed to load categories!')
            })
    },
    [GET_PRODUCT_AGE_GROUP_LIST]: () => async (dispatch) => {
        await Http.GET('fetchAgeGroup')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_AGE_GROUP_LIST],
                    payload: response.data?.map((item) => ({
                        id: item.constant,
                        name: item.name
                    }))
                })
            })
            .catch(() => {
                toast.error('Failed to load categories!')
            })
    },
    [GET_ALL_FABRIC_TYPES]: () => async (dispatch) => {
        await Http.GET('getAllMaterialCatagory')
            .then(async (response) => {
                await dispatch({
                    type: FilterOptionTypes[SET_ALL_FABRIC_TYPES],
                    payload: response.data?.map((item) => ({
                        id: item.code,
                        name: item.value
                    }))
                })
            })
            .catch(() => {
                toast.error('Failed to load categories!')
            })
    },
    [GET_DESIGN_LOOK]: () => async (dispatch) => {
        const data = await fetchEnumValues('info.nitex.app.product.DesignLook')
        await dispatch({
            type: FilterOptionTypes[SET_ALL_DESIGN_LOOK],
            payload: data?.map((item) => ({
                id: item.constant,
                name: item.name
            }))
        })
    }
}

const handleFilterDispatch = (fieldsType, data, dispatch) => {
    for (let item in fieldsType) {
        switch (item) {
            case 'DESIGN_LOOK':
                dispatch({
                    type: FilterOptionTypes[SET_ALL_DESIGN_LOOK],
                    payload: data?.designLookList?.map((item) => ({
                        id: item.constant,
                        name: item.name
                    }))
                })
                break
            case 'CATEGORY':
                dispatch({
                    type: FilterOptionTypes[SET_CATEGORY_LIST],
                    payload: data.categoryList
                })
                break
            case 'SEASON':
                dispatch({
                    type: FilterOptionTypes[SET_SEASON_LIST],
                    payload: data?.seasonList?.map((item) => ({
                        id: item.constant,
                        name: item.name
                    }))
                })
                break
            case 'FABRIC':
                dispatch({
                    type: FilterOptionTypes[SET_FABRIC_LIST],
                    payload: data.fabricTypeList
                })
                break
            case 'DEPARTMENT':
                if (data?.marketList?.length > 0) {
                    dispatch({
                        type: FilterOptionTypes[SET_DEPARTMENTS_LIST],
                        payload: data?.marketList
                    })
                }
                break
            case 'COMPOSITION':
                dispatch({
                    type: FilterOptionTypes[SET_COMPOSITION_LIST],
                    payload: data?.fiberList
                })
                break
            default:
                break
        }
    }
}

export const fetchFilterFieldsThunk = createAsyncThunk(
    'filters/fetchFilterFields',
    async ({ fieldsType, isExploreDesignPage }, { dispatch }) => {
        const queryParam = isExploreDesignPage
            ? '?isExploreDesignPage=true'
            : ''
        const data = await fetchFilterListByBuyer(queryParam)

        handleFilterDispatch(fieldsType, data, dispatch)
    }
)
